import { defineStore } from 'pinia';
import PricingRulesAPI from 'dashboard/api/planning/pricingRules';

export const usePricingRulesStore = defineStore('pricingRules', {
  state: () => ({
    records: [],
    currentPlanId: null,
    uiFlags: {
      isFetching: false,
      isCreating: false,
      isUpdating: false,
      isDeleting: false,
    },
  }),

  getters: {
    getRecords: state => state.records,
    getUIFlags: state => state.uiFlags,
    getRuleById: state => id => state.records.find(r => r.id === id),
  },

  actions: {
    async get(planId) {
      this.currentPlanId = planId;
      this.uiFlags = { ...this.uiFlags, isFetching: true };
      try {
        const response = await PricingRulesAPI.getAll(planId);
        this.records = response.data;
        return response.data;
      } finally {
        this.uiFlags = { ...this.uiFlags, isFetching: false };
      }
    },

    async create({ planId, ...payload }) {
      this.uiFlags = { ...this.uiFlags, isCreating: true };
      try {
        const response = await PricingRulesAPI.create(planId, payload);
        this.records.push(response.data);
        return response.data;
      } finally {
        this.uiFlags = { ...this.uiFlags, isCreating: false };
      }
    },

    async update({ planId, id, ...payload }) {
      this.uiFlags = { ...this.uiFlags, isUpdating: true };
      try {
        const response = await PricingRulesAPI.update(planId, id, payload);
        const index = this.records.findIndex(r => r.id === id);
        if (index >= 0) {
          this.records.splice(index, 1, response.data);
        }
        return response.data;
      } finally {
        this.uiFlags = { ...this.uiFlags, isUpdating: false };
      }
    },

    async delete({ planId, id }) {
      this.uiFlags = { ...this.uiFlags, isDeleting: true };
      try {
        await PricingRulesAPI.delete(planId, id);
        this.records = this.records.filter(r => r.id !== id);
      } finally {
        this.uiFlags = { ...this.uiFlags, isDeleting: false };
      }
    },
  },
});
